import ScheduleWrapper from './Schedule/ScheduleWrapper'

interface Props {
    days: string[],
    activities: Activity[],
    ursvik: boolean,
    header: string,
    info: string
}
interface Activity {
    day: string,
    time: string,
    type: string,
    room: string,
    grade: string,
    key: number
}

const Schedule = (props: Props) => {
    return (
        <section className="schedule" id="schedule">
            <h2>SCHEMA</h2>
            <h3>{props.header}</h3>
            <h4>{props.info}</h4>
            <ScheduleWrapper days={props.days} activities={props.activities} ursvik={props.ursvik}/>
        </section>
    );
};

export default Schedule;